import { Stack, Typography } from '@mui/material';
import { useConfigurationState } from '../lib/contexts/ConfigurationContext/ConfigurationContext';
import { useScreenLargerThan } from '../lib/hooks/breakpoint-hooks';

const NotFound = () => {
    const globalContextState = useConfigurationState();
    const isLargerThanSmall = useScreenLargerThan('sm');
    return (
        <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            sx={{
                width: '100%',
                height: `calc(100vh - ${globalContextState.headerOffsetHeight}px)`
            }}>
            <Typography sx={{ fontSize: isLargerThanSmall ? 56 : 26, fontWeight: 300 }}>
                404 Not Found
            </Typography>
        </Stack>
    );
};

export default NotFound;
